module.exports = __webpack_public_path__ + "static/media/promo2.f42e2b2d.png";